import { CanDeactivateFn } from '@angular/router';

/** Anything with unsaved work that can ask before leaving. */
export interface LeaveAware {
  canLeave(): boolean | Promise<boolean>;
}

/** Asks the editor before navigating away from unsaved changes. */
export const unsavedChangesGuard: CanDeactivateFn<LeaveAware> = (component) => component.canLeave();
